import React, { useEffect, useState } from 'react';
import { Button, OtpInput } from '../../components/common';
import { USE_MOCK } from '../../api/client';
import { formatPhone } from '../../utils/format';

/** Shared "enter the 6-digit SMS code" step with resend countdown. */
export default function OtpStep({
  countryCode, phone, onVerify, onResend, loading, error, submitLabel = 'Verify', hint,
}) {
  const [code, setCode] = useState('');
  const [wait, setWait] = useState(30);

  useEffect(() => {
    if (wait <= 0) return undefined;
    const t = setTimeout(() => setWait((w) => w - 1), 1000);
    return () => clearTimeout(t);
  }, [wait]);

  const resend = async () => {
    await onResend();
    setWait(30);
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (code.length === 6) onVerify(code);
      }}
    >
      <p className="auth__lead">
        {'Enter the 6-digit code sent to '}
        <strong>{formatPhone(countryCode, phone)}</strong>
      </p>
      <OtpInput value={code} onChange={setCode} />
      {error && <p className="field__error">{error}</p>}
      {USE_MOCK && hint && <p className="field__hint">{hint}</p>}
      <Button type="submit" block className="u-mt-6" disabled={code.length !== 6} loading={loading}>
        {submitLabel}
      </Button>
      <p className="auth__resend">
        {wait > 0 ? `Resend code in ${wait}s` : (
          <button type="button" className="link" onClick={resend}>Resend code</button>
        )}
      </p>
    </form>
  );
}
